import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9bdbe734"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "JobBoardItem__Inner" }
const _hoisted_2 = { class: "JobBoardItem__Title text-lg" }
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = { class: "JobBoardItem__Recruiter" }
const _hoisted_6 = {
  key: 0,
  class: "round"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = { class: "JobBoardItem__Apply__Wrapper" }
const _hoisted_10 = { class: "JobBoardItem__DisabledCursor" }
const _hoisted_11 = { class: "picture" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", { srcset: "/images/job-board/disabled.png 1x, /images/job-board/disabled@2x.png 2x" }, null, -1))
const _hoisted_13 = ["alt"]
const _hoisted_14 = { class: "JobBoardItem__Apply__Disabled" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 22 22" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-report" })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "JobBoardItem__Scroller" }
const _hoisted_18 = { class: "JobBoardItem__Text" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonSave = _resolveComponent("ButtonSave")!
  const _component_CursorFollow = _resolveComponent("CursorFollow")!
  const _component_ButtonClose = _resolveComponent("ButtonClose")!
  const _component_JobBoardApplyPopin = _resolveComponent("JobBoardApplyPopin")!
  const _component_JobBoardReportPopin = _resolveComponent("JobBoardReportPopin")!

  return (_openBlock(), _createBlock(_Transition, { name: "job" }, {
    default: _withCtx(() => [
      (_ctx.job)
        ? (_openBlock(), _createElementBlock("article", {
            class: "JobBoardItem",
            key: 'job-' + _ctx.job.slug
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("header", null, [
                _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.job.title), 1),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.job.restaurant), 1),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.job.location), 1),
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.job.recruiter_img)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("img", {
                          src: _ctx.job.recruiter_img,
                          alt: _ctx.job.recruiter
                        }, null, 8, _hoisted_7)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("dashboard.posted_by")) + " " + _toDisplayString(_ctx.job.recruiter), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.user.hasCompletedProfile)
                    ? (_openBlock(), _createBlock(_component_ButtonSave, {
                        key: 0,
                        class: _normalizeClass(["button button--black button--small JobBoardItem__Apply", { 'applied': _ctx.job.applied }]),
                        onClick: _ctx.onApply,
                        saved: _ctx.job.applied
                      }, {
                        saved: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('jobBoard.applied')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('jobBoard.apply')) + " ", 1)
                        ]),
                        _: 1
                      }, 8, ["class", "onClick", "saved"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_CursorFollow, null, {
                          cursor: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("picture", _hoisted_11, [
                                _hoisted_12,
                                _createElementVNode("img", {
                                  src: "/images/job-board/disabled.png",
                                  alt: _ctx.$t('jobBoard.disabled')
                                }, null, 8, _hoisted_13)
                              ]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('jobBoard.disabled')), 1)
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_ButtonSave, {
                              class: "button button--black button--small",
                              disabled: ""
                            }, {
                              saved: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('jobBoard.applied')), 1)
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('jobBoard.apply')) + " ", 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('jobBoard.disabled')), 1)
                      ], 64)),
                  _createElementVNode("button", {
                    class: "JobBoardItem__Report",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onReport && _ctx.onReport(...args)))
                  }, _hoisted_16)
                ]),
                _createVNode(_component_ButtonClose, {
                  class: "JobBoardItem__Close",
                  to: "/job-board",
                  variant: "dark"
                })
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t('jobBoard.aboutUs')), 1),
                  _createElementVNode("p", {
                    innerHTML: _ctx.job.aboutUs
                  }, null, 8, _hoisted_19),
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t('jobBoard.aboutJob')), 1),
                  _createElementVNode("p", {
                    innerHTML: _ctx.job.aboutJob
                  }, null, 8, _hoisted_20),
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t('jobBoard.salary')), 1),
                  _createElementVNode("p", {
                    innerHTML: _ctx.job.salary
                  }, null, 8, _hoisted_21)
                ])
              ])
            ]),
            _createVNode(_component_JobBoardApplyPopin, { ref: "applyPopin" }, null, 512),
            _createVNode(_component_JobBoardReportPopin, { ref: "reportPopin" }, null, 512)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}